// src/plugins/vuetify.js
import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import "@fortawesome/fontawesome-free/css/all.css";

Vue.use(Vuetify);

const vuetify = new Vuetify({
  rtl: false,
  theme: {
    dark: false, // You can toggle this dynamically later
    themes: {
      light: {
        primary: "#3A7AFE",
        secondary: "#66BB6A",
        accent: "#FF8F00",
        background: "#F5F7FA",
        surface: "#FFFFFF",
        error: "#F44336",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
      },
      dark: {
        primary: "#82B1FF",
        secondary: "#81C784",
        accent: "#FFB300",
        background: "#121212",
        surface: "#1E1E1E",
        error: "#EF5350",
        info: "#29B6F6",
        success: "#66BB6A",
        warning: "#FFA000",
      },
    },
  },
  icons: {
    iconfont: "fa",
  },
});

export default vuetify;
